<template>
  <div>
    <div class="col-12">
      <Title :page="page" />
      <breadcrumb :page="page" />
    </div>
    <div class="col-12">
      <div class="row w-defined">
        <div class="p-0" :class="{ 'sticky-bottom-right': stickyButtons }">
          <router-link to="/pei/detail">
            <ActionButton
              i="fas fa-arrow-circle-left"
              variant="outline-success m-2"
              name="btnRegresar"
            >
              Regresar
            </ActionButton>
          </router-link>
          <ActionButton
            v-if="!this.model.isSubmitted"
            i="fas fa-flag-alt"
            variant="outline-success m-2"
            @click="onSubmit"
          >
            Someter
          </ActionButton>
          <ActionButton
            v-if="canRestore"
            i="fas fa-undo"
            variant="outline-success m-2"
            @click="onUnSubmit"
          >
            Restablecer
          </ActionButton>
          <ActionButton
            v-if="!this.model.isSubmitted"
            i="fas fa-save"
            variant="success m-2"
            @click="onSave"
          >
            Guardar
          </ActionButton>
        </div>
      </div>
      <div class="dropdown-divider pb-2 w-100" />
    </div>

    <div v-if="questionnaire.length > 0" class="col-12">
      <Section1
        :key="componentKey"
        :model="questionnaireSection1"
        :readonly="readonly"
        class="mb-5"
        @changed="onSectionChanged"
      />

      <Section2
        :key="componentKey"
        :model="questionnaireSection2"
        :readonly="readonly"
        class="mb-5"
        @changed="onSectionChanged"
      />

      <Section3
        :key="componentKey"
        ref="section3"
        :model="questionnaireSection3"
        :list="questionnaire"
        :readonly="readonly"
        @changed="onSectionChanged"
      />
    </div>
    <customModal
      :message-box="{
        title: 'Terminos y Responsabilidades',
        messageCode: '0547',
        type: 'confirm',
        icon: 'fa fa-exclamation',
        size: '',
      }"
      :checkbox="{
        label: 'Acepto los términos y responsabilidades',
        Show: true,
        isRequired: true,
        validationMessage: termsResponsibilitiesModalErrorMessage,
      }"
      :success-callback="onSubmitModal"
      :cancel-callback="onCloseModal"
    />
  </div>
</template>
<script>
import ActionButton from '@/components/common/ActionButton';
import customModal from '@/components/common/modal/custommodal';
import breadcrumb from '@/components/common/page/TitleBreadcrumb';
import PeiStatus from '@/utils/constants/pei/peiStatus';
import mixAlert from '@/mixin/alert.mixin';
import mixWait from '@/mixin/loading.mixin';
import Section1 from './Section1';
import Section2 from './Section2';
import Section3 from './Section3';
import store from '@/store/index';
import yesOrNotEnum from '@/utils/constants/yesOrNotEnum';
import JQuery from 'jquery';
let $ = JQuery;
export default {
  name: 'EvaluationServiceTransition',
  mixins: [mixAlert, mixWait],
  components: {
    breadcrumb,
    Section1,
    Section2,
    Section3,
    customModal,
    ActionButton,
  },
  data() {
    return {
      page: {
        icon: 'fas fa-user-edit',
        title: 'Cuestionario de Transición',
        routes: [
          'Inicio',
          'PEI',
          'Crear/Modificar PEI / Cuestionario de Transición',
        ],
      },
      readonly: false,
      user: store.state.userProfile.sub,
      peiId: store.getters.SelectedPei,
      model: {
        submittedBy: '',
        peiId: '',
        evaluationServiceTransitionSubmittionId: null,
        studentSieId: store.getters['$_student/StudentSie'],
        isSubmitted: false,
        section: [],
        answer: [],
      },
      saved: false,
      isValid: false,
      questionnaire: [],
      questionnaireSectionValid: [
        { id: 1, valid: false },
        { id: 2, valid: false },
        { id: 3, valid: false },
      ],
      questionnaireSection1: {},
      questionnaireSection2: {},
      questionnaireSection3: {},
      validationMessages: [],
      errorMessage: '',
      termsResponsibilitiesModalMessage: '',
      termsResponsibilitiesModalErrorMessage: '',
      stickyButtons: {
        type: Boolean,
        Default: false,
      },
      componentKey: 0,
    };
  },
  created() {
    this.loadValidationMessages();
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  computed: {
    canRestore() {
      return (
        this.model.isSubmitted &&
        this.$store.getters.SelectedPeiStatus == PeiStatus.Completado
      );
    },
    yesOrNotEnum() {
      return yesOrNotEnum;
    },
  },
  mounted() {
    this.Info = this.$attrs.Info;
    this.getSubmittion();
  },
  methods: {
    getQuestionnaire() {
      this.$ApiGet(
        `/api/questionnaire/questions/?questionnaireType=1&peiId=${this.peiId}`
      )
        .then((res) => {
          this.questionnaire = res.data;
          this.questionnaire.map((section) => {
            let agencies = null;
            if (section.id === 2) {
              agencies = section.questions.filter((q) => q.id === 16);
              agencies.map((agency) => {
                agency.answers.map((agencyanswer) => {
                  const answer = this.model.answer.find(
                    (x) =>
                      x.questionnaireQuestionId === agency.id &&
                      agencyanswer.id === x.questionnaireAnswerId
                  );
                  agencyanswer.selected = null;
                  if (answer) {
                    agencyanswer.openAnswer = answer.openAnswer;
                    agencyanswer.selected = answer.questionnaireAnswerId;
                  }
                });
              });
            }

            section.questions.map((question) => {
              if (question.id == 11) {
                question.agencies = agencies;
              }
              const answer = this.model.answer.find(
                (x) => x.questionnaireQuestionId === question.id
              );
              question.selected = null;
              if (answer) {
                question.openAnswer = answer.openAnswer;
                question.selected = answer.questionnaireAnswerId;
              }

              return question;
            });

            return section;
          });

          this.questionnaireSection1 = this.questionnaire.find(
            (x) => x.id === 1
          );
          this.questionnaireSection2 = this.questionnaire.find(
            (x) => x.id === 2
          );
          this.questionnaireSection3 = this.questionnaire.find(
            (x) => x.id === 3
          );

          //Question 'El PEI contiene los requisitos establecidos por ley para cumplir con el indicador B13'
          //This question is disabled by default and selected as No (false)
          // both ids are the same question, but for different academicYearId conf.
          const questionB13Ids = [15, 753];
          const questionB13Found = this.questionnaireSection3.questions.find(
            (x) => questionB13Ids.some((id) => id === x.id)
          );
          questionB13Found.disabled = true;
          questionB13Found.selected = this.yesOrNotEnum.no;
        })
        .catch((err) => {
          this.response = err;
        });
    },
    loadValidationMessages() {
      const promise = this.$ApiGet(
        '/api/validationsmessages?messageCodes=0229&messageCodes=0547&messageCodes=0397&messageCodes=0732&&messageCodes=0636'
      );
      promise.then((res) => {
        this.validationMessages = res.data;

        this.termsResponsibilitiesModalErrorMessage = this.getMessage(
          '0229'
        ).name;
        this.termsResponsibilitiesModalMessage = this.getMessage('0547').name;
      });
    },
    getMessage(code) {
      const message = this.validationMessages.find(
        (element) => element.id == code
      );
      return message;
    },
    // an empty method ? O_O
    validate() {},
    onSectionChanged(section, isValid, message = '') {
      this.questionnaireSectionValid.find(
        (x) => x.id === section.id
      ).valid = isValid;

      if (section.id === 2) {
        this.errorMessage = message;
      }

      if (section.id === 3 && message !== '') {
        this.errorMessage = this.getMessage(message).name;
      }

      if (section.id === 1 || section.id === 2) {
        this.$refs.section3.validate();
      }
    },
    getSubmittion() {
      this.$ApiGet('api/pei/evaluationservicetransition?peiid=' + this.peiId)
        .then((response) => {
          this.model = response.data;
          if (this.model.evaluationServiceTransitionSubmittionId) {
            this.saved = true;
          }

          this.readonly = this.model.isSubmitted;

          this.getQuestionnaire();
        })
        .catch((err) => {
          this.response = err;
        });
    },
    save() {
      const answer = [];
      this.model.peiId = this.peiId;
      this.questionnaire.forEach((section) => {
        section.questions
          .filter((x) => x.selected && x.id !== 16)
          .forEach((question) => {
            const newAnswer = {
              questionnaireQuestionId: question.id,
              questionnaireAnswerId: question.selected,
              openAnswer: question.openAnswer,
            };
            answer.push(newAnswer);
          });
      });

      this.questionnaire.forEach((section) => {
        section.questions
          .filter((x) => x.id === 16)
          .forEach((question) => {
            question.answers
              .filter((x) => x.selected)
              .forEach((answerItem) => {
                const newAnswer = {
                  questionnaireQuestionId: question.id,
                  questionnaireAnswerId: answerItem.id,
                };
                answer.push(newAnswer);
              });
          });
      });

      this.model.answer = answer;

      this.$ApiPost('api/pei/evaluationservicetransition', this.model)
        .then(() => {
          this.saved = true;
          this.ShowToast('', this.getMessage('0636').name, 'success');

          this.readonly = this.model.isSubmitted;
          this.showTermsResponsibilities = !this.model.isSubmitted;

          this.componentKey += 1;
        })
        .catch((err) => {
          this.response = err;
        });
    },
    onSubmit() {
      const questions = this.questionnaireSection1?.questions.concat(
        this.questionnaireSection2?.questions,
        this.questionnaireSection3?.questions
      );
      const hasOpenAnswerEmpty = questions.some(
        (x) =>
          x?.isOpenAnswer &&
          (x?.selected === this.yesOrNotEnum.no &&
            x?.openAnswer?.trim()?.length) === 0
      );

      if (
        hasOpenAnswerEmpty ||
        this.questionnaireSectionValid.findIndex((x) => !x.valid) !== -1
      ) {
        const message = this.errorMessage
          ? this.errorMessage
          : this.getMessage('0397').name;
        this.ShowToast('', message, 'error');
        return;
      }

      if (!this.saved) {
        this.ShowToast(
          '',
          'Favor guardar los datos entrados del Indicador 13 y luego proceda a someter el mismo.',
          'error'
        );
        return;
      }
      $('#popup').modal('show');
    },
    onUnSubmit() {
      this.model.isSubmitted = false;
      this.model.submittedBy = this.user;
      this.save();
    },
    onCloseModal() {},
    onSave() {
      this.save();
    },
    onSubmitModal(isChecked) {
      if (!isChecked) {
        this.ShowToast('', this.getMessage('0229').name, 'error');
        return;
      }
      this.model.isSubmitted = true;
      this.model.submittedBy = this.user;
      this.save();
    },
    handleScroll() {
      if (window.scrollY > 200) {
        this.stickyButtons = true;
      } else {
        this.stickyButtons = false;
      }
    },
  },
};
</script>
<style scoped>
.w-defined {
  display: flex;
  flex-direction: row-reverse;
}

.sticky-bottom-right {
  position: fixed;
  bottom: 50px;
  right: 50px;
  z-index: 1;
}
</style>
